// extracted by mini-css-extract-plugin
export default {"page":"devices_page__CjO8p","header":"devices_header__VLvrv","listBx":"devices_listBx__aBWt0","listItem":"devices_listItem__jeNy4"};